import React from 'react';
import { Select } from 'antd';

const { Option } = Select;

const LeagueDropdown = ({ setFilterLeague,leagues }) => {
  const handleChange = value => setFilterLeague(value);

  return (
    <Select placeholder="Filter by League" onChange={handleChange} style={{ width: 200, marginBottom: 16 }} allowClear={true}>
        {leagues.map(x=><Option key={x.leagueID} value={x.leagueID}>{x.leagueName}</Option>)}
    </Select>
  );
};

export default LeagueDropdown;  
